import { useEffect } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom'
import { useAuth } from '../contexts/auth'
import { APP_ROUTES } from './routes';
import { Authentication } from '../api/Authentication';
import Cookies from 'js-cookie';
import { useToasts } from '../contexts/toasts';


export default function AppRouter() {
  const { pathname } = useLocation();
  const { token, loggedUser, setLoggedUser } = useAuth();
  const { showToast } = useToasts();
  const routes = useRoutes(APP_ROUTES);

  useEffect(() => {
    if (token && !loggedUser) {
      Authentication.userInfo()
        .then(
          ({ data }) => {
            setLoggedUser(data);
            Cookies.set(window.__env.AUTH_USER_NAME || "alida-user", JSON.stringify(data));
          },
          (err) => {
            const message = err.response?.data?.message || err.message;
            const status = err.response?.status;
            showToast('user-error', message, `User Error ${status ? `(${status})` : ''}`, 'danger');
          }
        )
    }
  }, [token, loggedUser, setLoggedUser, showToast]);

  if (pathname !== "/login" && !token) return <Navigate to="/login" />
  // it would change route before checking on user status
  // else if (pathname === "/login" && token) return <Navigate to="/" />;

  return routes;
}